export default __webpack_public_path__ + "static/media/step_icon_2.8759946c.png";